module.exports = __webpack_public_path__ + "img/spotImg.51238b31.jpg";